Controller = App.loadClass 'core::Angular/Controller'

# Controller for handling setting radio-button style options for
# management zones. For example, irrigated status is either "Yes" or "No",
# whereas productivity is one of a longer list of options, displayed in a
# dropdown
class exports.ZoneRadioSettingsController extends Controller

    constructor: (@scope, @transitions, @zone_type, option_name, option_type, options, @validation, @pgis) ->
        # prevent errors when refreshing or navigating directly to this step
        if not @pgis.field_data? and not @validation.canContinue()
            return

        ### needs done dynamically from router ###
        @scope.units = 'bu/ac'
        @scope.disabled.back = false
        ######
        @scope.multiSet = @multiSet
        @scope.update = @update
        @scope.option_name = option_name
        @scope.value_options = options
        @scope.option_type = option_type
        @scope.field_data = if @pgis?.field_data? then @pgis.field_data else @validation.getFieldData()
        @scope.zone_object = @setZoneObject()
        @scope.cleanup = @cleanup
        @scope.updateFromSelect = @updateFromSelect
        @scope.zone_type = @zone_type
        # set flag
        @scope.field_data.visited_settings = true

        # extra info
        @formatExtraInfo()
        # set default crop
        @scope.selected =
            crop: @getDefaultCrop()
        # set yield ranges
        @scope.crops_ranges = @makeCropRanges()
        @scope.crops = Object.keys(@scope.crops_ranges)
        # set select options
        @scope.select_options = @getSelectOptions(@zone_type) if @scope.option_type is 'select'

        # setup validation
        @scope.validation = @validation
        @scope.validate = @validate
        @scope.validation.setStepScope(@scope)
        @scope.load_data = @dataNeedsLoaded()

        @scope.blocks = {
            green: {
                values: ['Irrigated', 'High', 'Soybeans']
                color: '#3A894C'
            }
            yellow: {
                values: ['Med', 'Corn (grain)']
                color: '#E5B032'
            }
            red: {
                values: ['Dryland', 'Low']
                color: '#BE4948'
            }
            blue: {
                values: ['Other']
                color: '#3286AB'
            }
        }

        # add layers if needed
        @checkMapLayers()
        # load data?
        if @scope.load_data
            @loadEditData()
        else
            @pgis.setZoneObject(@scope.zone_object)

        @transitionStart = @transitions.onStart {}, ($transition) =>
            if @zone_type is 'irrigation'
                @pgis.setIrrigationZone(@scope.zone_object)
            if @zone_type is 'previous-crop'
                @pgis.setPreviousCropZone(@scope.zone_object)
            if @zone_type is 'productivity'
                @pgis.setProductivityZone(@scope.zone_object)

            if _.startsWith($transition.to().name, 'grower.fields-define')
                @scope.died_willingly = true
            # remove layers if we are on the last step for the zone
            if @scope.option_type is 'select' or @scope.zone_type is 'previous-crop'
                for z in @scope.zone_object.zones
                    # clear layer from map
                    App.map.removeLayer z.visible
                # clear stored data for the next zone
                @pgis.setFieldData(null)
                @pgis.setZoneObject(null)

        # dynamically set step number based on type
        switch_step = if @zone_type is 'previous-crop' then 1 else 2

        @scope.$parent.steps.once 'switch-from', "grower.fields-define.#{@zone_type}-settings#{switch_step}", (data) =>
            if data.is_forward
                # reset it for the next zone
                @scope.field_data.visited_settings = null
                @validation.setFieldData(@scope.field_data)

        @scope.$on '$destroy', () =>
            if not @scope.died_willingly
                # clear layers
                @validation.clearLayers()
                # clear settings
                @validation.settings = {}

            @transitionStart()

        @scope.validation.validate()
        @ensureZoneValuesAreSet()
        @validation.setBackButtonDisable(@scope.field_data, false)

        @scope.$watch 'selected.crop', (crop, old) =>
            if crop is old
                return

            @scope.select_options = @getSelectOptions(@zone_type, true) if @scope.option_type is 'select'
            @scope.validation.validate()

    formatExtraInfo: () =>
        if typeof @scope.zone_object.extra_info is 'string'
            @scope.zone_object.extra_info = JSON.parse(@scope.zone_object.extra_info)
        @scope.zone_object.extra_info ?=
            crop: ''
            units: ''
            name_add: ''
            mappings: []

    ensureZoneValuesAreSet: () =>
        for zone in @scope.zone_object.zones
            if not zone?.settings?[@scope.option_name]? and zone?.value?
                @update(zone.value, zone)
                zone.settings[@scope.option_name] = zone.value

    checkMapLayers: () =>
        for za in @scope.zone_object.zones
            exists = false
            App.map.eachLayer (l) =>
                if l is za.visible
                    exists = true

            za.visible.addTo(App.map) if not exists

    cleanup: () =>
        delete @scope.field_data
        delete @scope.zone_object

    setZoneObject: () =>
        zone = false
        if @zone_type is 'irrigation' and @pgis.getIrrigationZone()
            zone = @pgis.getIrrigationZone()
        if @zone_type is 'previous-crop' and @pgis.getPreviousCropZone()
            zone = @pgis.getPreviousCropZone()
        if @zone_type is 'productivity' and @pgis.getProductivityZone()
            zone = @pgis.getProductivityZone()

        if zone
            for z in zone.zones
                @showOnMap(z, false)
            return zone

        # we're on a second settings step
        if @scope.option_type is 'select'
            return @pgis.getZoneObject()

        return @scope.$parent.field_data.zones[@zone_type]

    showOnMap: (zone, update = true) =>
        if update
            geojson = L.GeoUtil.multiPolygonize(zone.visible.toGeoJSON())
            zone.geojson = geojson
        else
            geojson = zone.visible.toGeoJSON()

        zone.visible.clearLayers()

        # set layer styles
        L.geoJson(geojson).eachLayer (l) =>
            l.setStyle({ weight: 2, color: zone.color, fillOpacity: 0.6 })
            zone.visible.addLayer(l)
            @pgis.added_layers.push l

        # add to map
        zone.visible.addTo App.map

    dataNeedsLoaded: () =>
        no_load_modes = ['zone-add', 'irrigation-add']
        return @scope.field_data.process_mode not in no_load_modes and @scope.option_type isnt 'select'

    getDefaultCrop: () =>
        if @validation.settings.crop
            return @validation.settings.crop
        else if @scope.zone_object?.extra_info?.crop
            return @scope.zone_object.extra_info.crop
        else
            return null

    getSelectOptions: (type, resetWithoutDefault = false) =>
        if type is 'irrigation'
            return @defaultSelectOptions([
                { name: 'Irrigated', values: @getCropRanges(), color: '#3A894C', selected: null }
                { name: 'Dryland', values: @getCropRanges(), color: '#BE4948', selected: null }
            ], resetWithoutDefault)
        else
            return @defaultSelectOptions([
                { name: 'High', values: @getCropRanges(), color: '#3A894C', selected: null }
                { name: 'Med', values: @getCropRanges(), color: '#E5B032', selected: null }
                { name: 'Low', values: @getCropRanges(), color: '#BE4948', selected: null }
            ], resetWithoutDefault)

    defaultSelectOptions: (options, resetWithoutDefault) =>
        # we need to setup values so that the boxes will default if we are editing
        for option in options
            mapping = @getMapping(option.name)
            continue if not mapping?

            # default option selected to mapping value
            if mapping.value? and (option.selected is 0 or not option.selected) and not resetWithoutDefault
                option.selected = mapping.value

            # ensure we set values on each zone if needed
            if option.selected isnt 0
                for zone in @getZones(option.name)
                    zone.yield_value = option.selected
                    zone.yield_range = option.selected
                    zone.yield = option.selected

        return options

    updateFromSelect: (setting) =>
        @updateZoneObject() if @scope.zone_object?.extra_info?
        @ensureMappingIsSet(setting)

        @constrainProductivitySetting(setting)

        for zone in @scope.zone_object.zones
            if zone.value is setting.name
                # update block
                zone.color = setting.color
                zone.yield_range = setting.selected
                zone.selected_crop = @scope.selected.crop
                zone.zone_type = @zone_type

                @showOnMap(zone)

    updateZoneObject: () =>
        @scope.zone_object.selected_crop = @scope.selected.crop
        @scope.zone_object.zone_type = @zoneTypeToUpper(@zone_type)
        @scope.zone_object.extra_info.crop = @scope.selected.crop
        @scope.zone_object.extra_info.name_add = @scope.selected.crop
        @scope.zone_object.extra_info.units = @scope.units

    ensureMappingIsSet: (option) =>
        @scope.zone_object.extra_info.crop = @scope.selected.crop
        @setMapping(option.name, option.selected)
        for zone in @getZones(option.name)
            zone.yield_value = option.selected
            zone.yield_range = option.selected

    constrainProductivitySetting: (setting) =>
        for option in @scope.select_options
            low = option.selected if option.name is 'Low'
            med = option.selected if option.name is 'Med'
            high = option.selected if option.name is 'High'

        switch setting.name
            when 'Low'
                if setting.selected > med
                    @setYieldSetting 'Med', setting.selected
                if setting.selected > high
                    @setYieldSetting 'High', setting.selected

            when 'High'
                if setting.selected < med
                    @setYieldSetting 'Med', setting.selected
                if setting.selected < low
                    @setYieldSetting 'Low', setting.selected

            when 'Med'
                if setting.selected < low
                    @setYieldSetting 'Low', setting.selected
                if setting.selected > high
                    @setYieldSetting 'High', setting.selected

    setYieldSetting: (name, value) =>
        # Set the display dropdown
        for setting in @scope.select_options
            if setting.name is name
                setting.selected = value

        # Set the backend object
        for zone in @getZones(name)
            zone.yield_range = value

    validate: (ending) =>
        # ensure that each input has a value selected
        @validation.setFieldData(@scope.field_data)
        # validate both steps
        if @scope.option_type is 'button'
            for zone in @scope.zone_object.zones
                if not zone?.value? or zone?.value is 'false'
                    return false
        else if @scope.option_type is 'select'
            for zone in @scope.zone_object.zones
                if not zone.yield_range? or zone.yield_range is ''
                    return false
            if not @scope.selected.crop
                return false

        # if we are about to move to the next step
        if ending
            # TODO: this shouldn't be in the validate function. Can we just set
            # the average at the same time as we set each mapping?
            if @scope.option_type is 'select'
                for option in @scope.select_options
                    if @getZones(option.name).length is 0
                        continue
                    range = @getRangeByMin(option.selected)
                    average = (range.min + range.max) / 2
                    @setMapping("#{option.name} average", average)

            @pgis.setZoneObject @scope.zone_object

        return true

    multiSet: (value) =>
        for z in @scope.zone_object.zones
            z.settings[@scope.option_name] = value
            @update(value, z)

        @scope.validation.validate()

    zoneTypeToUpper: (type) =>
        switch type
            when 'previous-crop' then return 'Previous Crop'
            when 'irrigation' then return 'Irrigation'
            when 'productivity' then return 'Productivity'

    updateMappings: (name) =>
        @formatExtraInfo() # do we need this? can extra_info be overwritten?
        @setMapping(name)

    update: (value, zone) =>
        @updateZoneObject() if @scope?.zone_object?.extra_info?

        # iterate block values
        for color, properties of @scope.blocks
            # see if our value exists
            if value in properties.values
                # update block
                zone.color = properties.color
                zone.selected_crop = @scope.selected.crop
                zone.zone_type = @zone_type
                zone.value = value
                zone.updated = true
                zone.settings[@scope.option_name] = value
                # update mappings if needed
                @updateMappings(value)

                @showOnMap(zone)

        @pgis.setZoneObject(@scope.zone_object)

    loadRange: (zone) =>
        ###
            This now breaks for irrigation maps due to changes to the structure of irrigation map extra_info
            The controller that processes the irrigation data has also been changed, so we can skip this if the zone is irrigation
            https://www.pivotaltracker.com/story/show/153712733
        ###
        if @zone_type is 'irrigation'
            return
        # hax.. do we need this? we call getDefaultCrop in the constructor
        if not @scope.selected.crop
            @scope.selected.crop = 'Corn (grain)'

        mapping = @getMapping(zone.value)
        range = @getRangeByMin(mapping.value) if mapping?
        zone.yield_range = range.min if range?

    getMapping: (name) =>
        @scope.zone_object.extra_info.mappings ?= []
        for mapping in @scope.zone_object.extra_info.mappings
            if name.toLowerCase() is mapping.name.toLowerCase()
                return mapping

        return null

    setMapping: (name, value = null) =>
        ###
            This now breaks for irrigation maps due to changes to the structure of irrigation map extra_info
            The controller that processes the irrigation data has also been changed, so we can skip this if the zone is irrigation
            https://www.pivotaltracker.com/story/show/153712733
        ###
        if @zone_type is 'irrigation'
            return
        # TODO: it'd be way easier to prevent duplicating mappings if they were
        # just an associative array instead of an array of objects
        @scope.zone_object.extra_info.mappings ?= []
        for mapping in @scope.zone_object.extra_info.mappings
            if name.toLowerCase() is mapping.name.toLowerCase()
                mapping.value = value if value?
                return

        # if it doesn't exist yet, add it
        @scope.zone_object.extra_info.mappings.push
            name: name.toLowerCase()
            value: value ? ''

    getCropRanges: (crop = null) =>
        # we usually want the currently selected crop
        return @scope.crops_ranges[crop ? @scope.selected.crop]

    getRangeByMin: (min) =>
        for range in @getCropRanges()
            if range.min is min
                return range

        return null

    getZones: (value = null) =>
        @scope.zone_object.zones ?= []
        if not value?
            return @scope.zone_object.zones

        return @scope.zone_object.zones.filter (zone) ->
            return zone.value.toLowerCase() is value.toLowerCase()

    loadEditData: () =>
        # iterate areas
        for zone in @scope.zone_object.zones
            # iterate blocks
            for color, properties of @scope.blocks
                if zone.value in properties.values
                    # update block
                    zone.color = properties.color
                    zone.zone_type = @zone_type
                    zone.selected_crop = @scope.selected.crop
                    zone.settings[@scope.option_name] = zone.value
                    @loadRange(zone)

                    @showOnMap(zone)

    # this will probably need to be made into a db table, query object, and backend call
    makeCropRanges: () =>
        return {
            'Corn (grain)': @makeRangeObjects(x for x in [360..0] by -20)
            Soybeans: @makeRangeObjects(x for x in [120..0] by -5)
            Wheat: @makeRangeObjects(x for x in [120..0] by -5)
        }

    makeRangeObjects: (values) =>
        ranges = []
        stopper = values.length - 2
        for val, index in values
            if index >= stopper
                break

            # create an object containing all relevant information to this range
            ranges.push
                text: "#{values[index + 1]} - #{val}", # what the user will see
                min: val,
                max: values[index + 1],
                index: ranges.length - 1

        # sort the array of ranges from min->max
        ranges.sort (a, b) ->
            return b.min - a.min

        return ranges
